import React from 'react';
import isEmpty from 'lodash/isEmpty';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ValidatedTextInput } from '@els/els-react--text-input';
import MultiInputPill from './MultiInputPill';

import './MultiInput.scss';

function MultiInput({
  values,
  multiInputOnRemove,
  createdRef,
  inputValue,
  inputOnChange,
  validationMessage,
  description,
  className,
  placeholder,
  placeholderWhenFilled,
  disabled = false,
  additionDisabled = false,
  classNameInput,
}) {
  const handleInputChange = (event) => {
    inputOnChange(event?.target?.value ?? '');
  };

  const hasValues = !isEmpty(values);

  return (
    <div className="els-multi-input-container">
      <fieldset className={classnames(['els-multi-input-wrapper', { disabled, 'has-values': hasValues }])} ref={createdRef}>
        <legend className="sr-only">Email addresses</legend>
        <ul className="els-multi-input-pills" aria-label="Selected email addresses">
          {hasValues &&
            values.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={index}>
                <MultiInputPill value={item.value} onRemove={() => multiInputOnRemove(index)} disabled={item.disabled || disabled} />
              </li>
            ))}
        </ul>
        <ValidatedTextInput
          id="id-multi-input-input"
          data-e2e="multi-input-text-input"
          className={classnames(['els-multi-input-input', className, classNameInput])}
          value={inputValue}
          onChange={handleInputChange}
          validator="email"
          placeholder={hasValues ? placeholderWhenFilled || '' : placeholder}
          disabled={disabled || additionDisabled}
          label={description || placeholder}
          shouldHideLabel
        />
      </fieldset>
      <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
        {validationMessage || ''}
      </div>
    </div>
  );
}

MultiInput.propTypes = {
  // props
  values: PropTypes.array,
  multiInputOnRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  additionDisabled: PropTypes.bool,

  // HOCs
  createdRef: PropTypes.object.isRequired, // withCreatedRef HOC
  inputValue: PropTypes.string, // withMultiInputStateHandlers HOC
  inputOnChange: PropTypes.func.isRequired, // withInputValueOnChange HOC
  validationMessage: PropTypes.string, // withMultiInputStateHandlers HOC

  // Input props
  className: PropTypes.string,
  classNameInput: PropTypes.string,
  placeholder: PropTypes.string,
  placeholderWhenFilled: PropTypes.string,
  description: PropTypes.string,
};

export default React.memo(MultiInput);
